document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("signupForm");
  const messageContainer = document.getElementById("form-message");
  const addressInput = document.getElementById("address");

  // Initialize Google Places Autocomplete
  const autocomplete = new google.maps.places.Autocomplete(addressInput, {
    types: ["geocode"],
  });

  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();
    addressInput.value = place.formatted_address || "";
  });

  // Handle form submission
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    const honeypot = formData.get("honeypot");
    const endpointUrl =
      "https://script.google.com/macros/s/AKfycbwJ3Uvq_-vjM7_okcCrsh7amwJK0U_vA8d4jVhuH4JadUDmsAWEC0DIvrU6Siz6c4lN/exec";

    // Honeypot check
    if (honeypot) {
      messageContainer.textContent = "Bot detected! Form submission rejected.";
      return;
    }

    messageContainer.textContent = "Submitting...";
    try {
      const response = await fetch(endpointUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      });

      const data = await response.json();

      if (response.ok && data.result === "success") {
        messageContainer.textContent = "Sign-up successful!";
        form.reset();
      } else {
        messageContainer.textContent = data.error || "Something went wrong.";
      }
    } catch (error) {
      messageContainer.textContent = "Error submitting the form.";
    }
  });
});
